var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#121B5C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8 11H25.2C28.4 11 31 13.6 31 16.8V25.2C31 26.7383 30.3889 28.2135 29.3012 29.3012C28.2135 30.3889 26.7383 31 25.2 31H16.8C13.6 31 11 28.4 11 25.2V16.8C11 15.2617 11.6111 13.7865 12.6988 12.6988C13.7865 11.6111 15.2617 11 16.8 11ZM16.6 13C15.6452 13 14.7295 13.3793 14.0544 14.0544C13.3793 14.7295 13 15.6452 13 16.6V25.4C13 27.39 14.61 29 16.6 29H25.4C26.3548 29 27.2705 28.6207 27.9456 27.9456C28.6207 27.2705 29 26.3548 29 25.4V16.6C29 14.61 27.39 13 25.4 13H16.6ZM26.25 14.5C26.5815 14.5 26.8995 14.6317 27.1339 14.8661C27.3683 15.1005 27.5 15.4185 27.5 15.75C27.5 16.0815 27.3683 16.3995 27.1339 16.6339C26.8995 16.8683 26.5815 17 26.25 17C25.9185 17 25.6005 16.8683 25.3661 16.6339C25.1317 16.3995 25 16.0815 25 15.75C25 15.4185 25.1317 15.1005 25.3661 14.8661C25.6005 14.6317 25.9185 14.5 26.25 14.5ZM21 16C22.3261 16 23.5979 16.5268 24.5355 17.4645C25.4732 18.4021 26 19.6739 26 21C26 22.3261 25.4732 23.5979 24.5355 24.5355C23.5979 25.4732 22.3261 26 21 26C19.6739 26 18.4021 25.4732 17.4645 24.5355C16.5268 23.5979 16 22.3261 16 21C16 19.6739 16.5268 18.4021 17.4645 17.4645C18.4021 16.5268 19.6739 16 21 16ZM21 18C20.2044 18 19.4413 18.3161 18.8787 18.8787C18.3161 19.4413 18 20.2044 18 21C18 21.7956 18.3161 22.5587 18.8787 23.1213C19.4413 23.6839 20.2044 24 21 24C21.7956 24 22.5587 23.6839 23.1213 23.1213C23.6839 22.5587 24 21.7956 24 21C24 20.2044 23.6839 19.4413 23.1213 18.8787C22.5587 18.3161 21.7956 18 21 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon1);
export default __webpack_public_path__ + "static/media/insta-icon-1.20bce6fb1b61188c050a1dd059d6ea72.svg";
export { ForwardRef as ReactComponent };